import { render, staticRenderFns } from "./AddDimitraOffice.vue?vue&type=template&id=0e915892&scoped=true"
import script from "./AddDimitraOffice.vue?vue&type=script&lang=js"
export * from "./AddDimitraOffice.vue?vue&type=script&lang=js"
import style0 from "./AddDimitraOffice.vue?vue&type=style&index=0&id=0e915892&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e915892",
  null
  
)

export default component.exports